import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Hammer, Scale } from "lucide-react";

const CONFIG = {
    "tahkim-dosyalari": {
        merkezTo: "/yeni/tahkim-merkezi",
        merkezLabel: "Tahkim Merkezi",
        icon: Scale,
        accent: "violet",
        title: "Bu sayfa veri girişi listesidir",
        body: "Kanban, hatırlatmalar, ön tahkim ve toplu işlemler için Tahkim Merkezi'ni kullanın.",
    },
    icralar: {
        merkezTo: "/yeni/icra-merkezi",
        merkezLabel: "İcra Merkezi",
        icon: Hammer,
        accent: "orange",
        title: "Bu sayfa icra kayıt listesidir",
        body: "Kanban, tahsilat takibi ve ödeme entegrasyonu için İcra Merkezi'ni kullanın.",
    },
};

export default function EntityMerkezBanner({ entityKey }) {
    const cfg = CONFIG[entityKey];
    if (!cfg) return null;
    const Icon = cfg.icon;
    const border =
        cfg.accent === "orange"
            ? "border-orange-500/30 bg-gradient-to-r from-orange-500/10 via-[#121A2F] to-transparent"
            : "border-violet-500/30 bg-gradient-to-r from-violet-500/10 via-[#121A2F] to-transparent";
    const btn =
        cfg.accent === "orange"
            ? "bg-orange-600/80 hover:bg-orange-600 text-white"
            : "bg-violet-600/80 hover:bg-violet-600 text-white";

    return (
        <div
            className={`mb-6 rounded-xl border px-4 py-3.5 flex flex-col sm:flex-row sm:items-center gap-3 ${border}`}
        >
            <div className="flex items-start gap-3 flex-1 min-w-0">
                <div className="h-10 w-10 rounded-lg border border-white/10 bg-[#0B0F19]/80 flex items-center justify-center shrink-0">
                    <Icon className="h-5 w-5 text-[#D4AF37]" />
                </div>
                <div>
                    <div className="text-sm font-semibold text-white">{cfg.title}</div>
                    <p className="text-xs text-slate-400 mt-0.5">{cfg.body}</p>
                </div>
            </div>
            <Link
                to={cfg.merkezTo}
                className={`inline-flex items-center justify-center gap-1.5 h-9 px-4 rounded-lg text-sm font-semibold shrink-0 ${btn}`}
            >
                {cfg.merkezLabel}
                <ArrowRight className="h-4 w-4" />
            </Link>
        </div>
    );
}
